// Communication bridge between web and native iOS app.
// Messages are sent via WebKit message handlers.
// Note: Nav bar buttons are handled by @joemasilotti/bridge-components.

export const TurboNativeBridge = {
  get isNative() {
    return navigator.userAgent.includes("Turbo Native") || navigator.userAgent.includes("DropKind")
  },

  getPendingShare() {
    return this._postMessage("getPendingShare", "pendingShareCallback")
  },

  clearPendingShare() {
    if (this.isNative && window.webkit?.messageHandlers?.clearPendingShare) {
      window.webkit.messageHandlers.clearPendingShare.postMessage({})
    }
  },

  requestAppStoreReview(requestId) {
    if (!this.isNative || !window.webkit?.messageHandlers?.requestAppStoreReview) {
      return false
    }

    window.webkit.messageHandlers.requestAppStoreReview.postMessage({ requestId })
    return true
  },

  getClipboardText() {
    return this._postMessage("getClipboardText", "clipboardTextCallback")
  },

  // Post a message to native and wait for callback response
  _postMessage(handlerName, callbackName, timeoutMs = 1000) {
    return new Promise((resolve) => {
      const handler = window.webkit?.messageHandlers?.[handlerName]
      if (!this.isNative || !handler) {
        resolve(null)
        return
      }

      window[callbackName] = (data) => {
        resolve(data)
        delete window[callbackName]
      }

      setTimeout(() => {
        if (window[callbackName]) {
          resolve(null)
          delete window[callbackName]
        }
      }, timeoutMs)

      handler.postMessage({})
    })
  }
}

window.TurboNativeBridge = TurboNativeBridge
